;(function($) {
	const introHeight = $('.intro').height()
	const $boxes = $('.biographie__box')
	const $items = $('.biographie__item')

	function resetBoxes() {
		$items.removeClass('active')
		$boxes.hide()
		$boxes.attr('aria-hidden', 'true')
	}

	$('.biographie__close').on('click', function(e) {
		e.preventDefault()
		resetBoxes()
	})

	$('.biographie__item-link').on('click', function(e) {
		e.preventDefault()
		resetBoxes()
		let tgt = $(this).attr('href')
		let $tgt = $(tgt)
		$(this)
			.parent()
			.addClass('active')
		$tgt.show()
		$tgt.attr('aria-hidden', 'false')
		$tgt.find('button').focus()

		$('html, body').animate(
			{
				scrollTop: $tgt.offset().top - introHeight - 140,
			},
			500
		)
	})
})(jQuery)
